<template>
  <div
    class="tripAdd"
    v-cloak
  >
    <div class="khto">
      <p @click="back">
        <van-icon
          color="#fff"
          name="arrow-left"
        />
      </p>
      <p style="color: #fff">
        {{ title }}
      </p>
      <p />
    </div>
    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="{use:false}"
      >
        <div class="pad-b-50">
          <div>
            <ul>
              <li>
                <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="value"
                  label="行程类型"
                  placeholder="点击选择行程类型"
                  @click="showPicker = true"
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                />
                <van-popup
                  v-model="showPicker"
                  position="bottom"
                >
                  <van-picker
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </li>
            </ul>
            <ul>
              <li>
                <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="Departurecity"
                  label="出发城市"
                  placeholder="出发城市"
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                  @click="getAirport(1)"
                />
              </li>
              <li>
                <van-field
                  v-if="roundtrip_chengshi"
                  readonly
                  clickable
                  name="picker"
                  :value="Arriveinthecity"
                  label="目的地"
                  placeholder="目的地"
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                  @click="getAirport(2)"
                />
              </li>
              <li>
                <van-field
                  v-if="roundtrip_chufariqi"
                  readonly
                  clickable
                  name="picker"
                  :value="Departuredate"
                  label="出发日期"
                  placeholder="出发日期"
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                  @click="showDate(1)"
                />
              </li>
            </ul>
            <!--            多程的行程-->
            <div
              v-if="Multipletravelmodules"
              v-for="(item,index) in apply.Multireach"
              :key="index++"
              @click="RoundTripEvents(index,item)"
            >
              <ul>
                <li>
                  <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="item.Departurecity"
                    :label="'第'+ index+'程目的地'"
                    placeholder="出发城市"
                    right-icon="arrow"
                    color="#000"
                    input-align="right"
                    @click="getAirport(1.1)"
                  />
                </li>
                <li v-if="index > 1">
                  <van-field
                    v-if="roundtrip_chufariqi"
                    readonly
                    clickable
                    name="picker"
                    :value="item.RoundTripDepartureDate"
                    label="出发日期"
                    placeholder="出发日期"
                    right-icon="arrow"
                    color="#000"
                    input-align="right"
                    @click="showDate(1)"
                  />
                </li>
              </ul>
              <ul v-if="roundtripcontrol">
                <li style="display: flex;align-items: center;">
                  <van-field
                    :label="$t('出差事由')"
                    clearable
                    style="width: 100px"
                  />
                  <input
                    placeholder="请输入出差原因"
                    class="kh-sy"
                    v-model="params.ccsy"
                    type="text"
                    @input="input"
                  >
                </li>
                <li style="display: flex;align-items: center;">
                  <van-field
                    readonly
                    clickable
                    name="picker"
                    label="项目出差 "
                    color="#000"
                    style="width: 345px"
                  />
                  <van-switch
                    size="15px"
                    v-model="checked1"
                    active-color="#7557e6"
                    inactive-color="#dcdee0"
                  />
                </li>
                <li v-if="checked1">
                  <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="params.projectName"
                    label="项目名称"
                    placeholder="请选择项目名称"
                    right-icon="arrow"
                    color="#000"
                    input-align="right"
                    @click="toggle('checkList', { type: '0' })"
                  />
                </li>
                <li
                  v-if="checked1"
                  v-show="false"
                >
                  <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="0"
                    label="费用承担"
                    placeholder="费用承担"
                    right-icon="arrow"
                    color="#000"
                    input-align="right"
                  />
                </li>
              </ul>
            </div>

            <ul v-if="businesstrip">
              <li>
                <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="Departuredate"
                  label="出发日期"
                  placeholder="出发日期"
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                  @click="showDate(1)"
                />
              </li>
            </ul>

            <!--            往返日期-->
            <ul v-if="roundt">
              <li>
                <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="Checkindate"
                  label="出发日期 "
                  placeholder="出发日期 "
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                  @click="showDate(2)"
                />
              </li>
              <li>
                <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="Checkoutdate"
                  label="返程日期"
                  placeholder="返程日期"
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                  @click="addRoute('10903')"
                />
              </li>
            </ul>
            <!--            酒店-->
            <ul v-if="businesstrip">
              <li style="display: flex;align-items: center;">
                <van-field
                  readonly
                  clickable
                  name="picker"
                  label="出差住宿"
                  color="#000"
                  style="width: 345px"
                />
                <van-switch
                  size="15px"
                  v-model="checked"
                  active-color="#7557e6"
                  inactive-color="#dcdee0"
                />
              </li>
            </ul>
            <ul v-if="checked">
              <li>
                <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="Checkindate"
                  label="入住日期"
                  placeholder="入住日期"
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                  @click="showDate(2)"
                />
              </li>
              <li>
                <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="Checkoutdate"
                  label="离店日期"
                  placeholder="离店日期"
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                  @click="addRoute('10903')"
                />
              </li>
            </ul>
            <!--            出差项目-->
            <ul v-if="roundtripisby">
              <li style="display: flex;align-items: center;">
                <van-field
                  :label="$t('出差事由')"
                  clearable
                  style="width: 100px"
                />
                <input
                  placeholder="请输入出差原因"
                  class="kh-sy"
                  v-model="params.ccsy"
                  type="text"
                >
              </li>
              <li style="display: flex;align-items: center;">
                <van-field
                  readonly
                  clickable
                  name="picker"
                  label="项目出差 "
                  color="#000"
                  style="width: 345px"
                />
                <van-switch
                  size="15px"
                  v-model="checked1"
                  active-color="#7557e6"
                  inactive-color="#dcdee0"
                />
              </li>
              <li v-if="checked1">
                <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="params.projectName"
                  label="项目名称"
                  placeholder="请选择项目名称"
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                  @click="toggle('checkList', { type: '0' })"
                />
              </li>
              <!--              添加多个行程的按钮-->

              <li
                v-if="checked1"
                v-show="false"
              >
                <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="this.zys"
                  label="费用承担"
                  placeholder="费用承担"
                  right-icon="arrow"
                  color="#000"
                  input-align="right"
                />
              </li>
            </ul>
            <ul>
              <li>
                <div>
                  <van-field
                    v-model="params.gzmc"
                    class="black"
                    label="审批规则"
                    required
                    readonly
                    is-link
                    @click="toggle('checkList', { type: 6 })"
                  />
                </div>
              </li>
            </ul>
            <van-button
              @click="Addatrip"
              type="primary"
              class="roundtripbutton"
              v-if="button"
            >
              添加行程
            </van-button>
          </div>
          <div
            class="pad-t-5"
            v-if="false"
          >
            <van-cell>
              <van-row
                type="flex"
                align="center"
              >
                <van-col span="20">
                  {{ $t('K106','项目出差') }}
                </van-col>
                <van-col
                  span="4"
                  class="text-right"
                >
                  <van-switch
                    size="18px"
                    v-model="params.project"
                  />
                </van-col>
              </van-row>
            </van-cell>
          </div>
          <div />
          <div
            v-if="
              false"
            class="pad-t-5"
            v-show="params.project"
          >
            <van-field
              label="选择项目"
              is-link
              required
              readonly
              placeholder="选择项目"
            />
            </span>
          </div>
          <div
            v-if="false"
            class="van-hairline--bottom pad-t-5 "
          >
            <!--            <van-field-->
            <!--              :label="$t('K107','目的地')"-->
            <!--              required-->
            <!--              :clearable="true"-->
            <!--              placeholder="请输入您的目的地（必填）"-->
            <!--              v-model="params.mdd"-->
            <!--            />-->
          </div>
          <van-field
            v-if="false"
            :label="$t('K001','成本中心')"
            readonly
            required
            is-link
            :placeholder="$t('K001','成本中心')"
            v-model="params.costCenterName"
            @click="toggle('checkList',{type:'1'})"
          />
          <!-- cbZxCode -->
          <van-field
            v-if="false"
            v-show="subjectCode.show"
            :label="$t('F054','科目码')"
            :placeholder="$t('F054','科目码')"
            v-model="params.subjectCode"
            right-icon="arrow"
            @click-right-icon="toggle('checkList',{type:'2'})"
            :readonly="subjectCode.write==false"
            :required="subjectCode.must"
          />
          <!-- sn -->
          <van-field
            v-if="false"
            :label="$t('K102','事由')"
            required
            clearable
            v-model="params.ccsy"
          />
          <!--差日期始  出差日期止-->
          <!--          <div class="pad-t-5">-->
          <!--            <van-row-->
          <!--              type="flex"-->
          <!--              align="center"-->
          <!--            >-->
          <!--              <van-col-->
          <!--                span="12"-->
          <!--                @click="showDate"-->
          <!--              >-->
          <!--                <van-field-->
          <!--                  v-model="params.dateBegin"-->
          <!--                  required-->
          <!--                  readonly-->
          <!--                  input-align="center"-->
          <!--                  placeholder="出差日始"-->
          <!--                />-->
          <!--              </van-col>-->
          <!--              <van-col-->
          <!--                span="12"-->
          <!--                readonly-->
          <!--                @click="showDate"-->
          <!--              >-->
          <!--                <van-field-->
          <!--                  required-->
          <!--                  input-align="center"-->
          <!--                  v-model="params.dateEnd"-->
          <!--                  placeholder="出差日止"-->
          <!--                />-->
          <!--              </van-col>-->
          <!--            </van-row>-->
          <!--          </div>-->
          <div
            class="pad-t-5"
            v-if="false"
          >
            <van-cell>
              <van-row class="text-center">
                <van-col span="12">
                  <van-tag
                    plain
                    size="large"
                    type="primary"
                  >
                    {{ $t('K103','行程计划') }}&nbsp;<van-icon name="add-o" />
                  </van-tag>
                </van-col>
                <van-col span="12">
                  <van-tag
                    plain
                    size="large"
                    type="primary"
                    @click="addRouters"
                  >
                    {{ $t('K104','住宿安排') }}&nbsp;<van-icon name="add-o" />
                  </van-tag>
                </van-col>
              </van-row>
            </van-cell>
          </div>
          <!--          <route-->
          <!--            class="pad-t-5"-->
          <!--            v-if="params.vipRoute&&params.vipRoute.length>0"-->
          <!--            :route="params.vipRoute"-->
          <!--            @delete="deletRoute"-->
          <!--          />-->
          <!--  费用预算 -->
          <van-cell v-if="false">
            {{ $t('E013','费用预算') }}
          </van-cell>
          <van-row v-if="false">
            <van-col span="12">
              <van-field
                :label="$t('E014','交通费')"
                v-model="params.jtys"
                label-width="60"
              />
            </van-col>
            <van-col span="12">
              <van-field
                :label="$t('E015','住宿费')"
                v-model="params.zsys"
                label-width="60"
              />
            </van-col>
          </van-row>
          <van-row v-if="false">
            <van-col span="12">
              <van-field
                :label="$t('E016','其它费用')"
                v-model="params.qtys"
                label-width="60"
              />
            </van-col>
            <van-col span="12">
              <van-field
                readonly
                label="总额"
                v-model="zys"
                label-width="60"
              />
            </van-col>
          </van-row>


          <div
            class="pad-t-5"
            v-if="false"
          >
            <van-field
              v-model="params.remark"
              class="black"
              :label="$t('K105','备注说明')"
              :placeholder="$t('bzsm','请输入备注说明')"
              @focus.prevent="changefocus"
            />
          </div>
        </div>
      </mescroll-vue>
    </div>

    <!--  -->
    <ld-tabbar>
      <van-row
        type="flex"
        align="center"
        class="full-width bg-white shadow khdis"
      >
        <span>
          <van-button
            class="khbutton1"
            plain
            type="primary"
            @click="submit(1)"
          >保存</van-button>
        </span>
        <span style="margin: 0 15px 0px 15px;">
          <van-button
            class="khbutton"
            type="info"
            @click="submit(2)"
          >提交</van-button>
        </span>
      </van-row>
    </ld-tabbar>
    <!-- 城市 -->
    <city
      ref="city"
      :sys-type="way"
      @selected="cityChange"
      :tab-index="pageCtrl.roundtrip"
      :cplx="cplx1"
      :city-type="0"
    />
    <!-- 日期 -->
    <Ld-calendar
      ref="date"
      :type="dateType"
      @selected="getDate"
      allow-same-day
      start-text="去程"
      end-text="回程"
    />


    <!-- 出差人 -->
    <ld-emp-list
      ref="empList"
      @selected="cxrCallBack"
      @radioSelected="ccrCallBack"
      :radio.sync="radio"
      :hide-person="params.ccrPerson"
    />

    <!-- c成本中心 科目码 -->
    <ld-check-list
      ref="checkList"
      @selected="checkCallBack"
    />
  </div>
</template>

<script >
import { Cell,Field,Switch ,Icon ,Tag,Form,Popup,Picker,NavBar,Button   } from 'vant'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import { mapGetters } from 'vuex'
import ldEmpList from 'Components/ldEmpList/index.vue'
import ldCheckList from 'Components/ldCheckList'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { getName, getEmpId } from 'Utils/publicFun'
import City from 'Common/city'
// import route from '../components/route'

import { changefocus } from 'Utils/tools'
import { queryParameter } from 'Utils/publicApi'
import {formatDate} from 'Utils/dateUtil'

export default {
  name: 'TripAdd',
  components:{
    [Cell.name]:Cell,
    [Field.name]:Field,
    [Switch.name]:Switch,
    [Icon.name]:Icon,
    [Tag.name]:Tag,
    [NavBar .name]:NavBar ,
    [Form.name]:Form,
    [Popup.name]:Popup,
    [Picker.name]:Picker ,
    [Button.name]:Button  ,
    ldTabbar,
    City,
    ldButton,
    ldCheckList,
    ldEmpList,
    MescrollVue,
    // route,
    LdCalendar: () => import('Common/ldCalendar'),
  },
  data: function() {
    return {
      index:'',
      appl:'',
      apply:{
        Multireach:[
          {
            Departurecity:'',//行程
            RoundTripDepartureDate:'*'//出发日期
          }
        ],
      },
      button:false,
      roundtripcontrol:false,//区分往返的事由
      Multipletravelmodules:false,//多个行程的模块
      roundtripisby:true,//往返 多个行程的模块
      roundtrip_chufariqi:false,//出发日期
      roundtrip_chengshi:true,//出发日期
      roundt:false,
      businesstrip:true,
      dateType: 'single',
      roundtrip: 0,
      ateType: null,
      startDate: new Date(),
      departDate: formatDate(new Date(), 1),//出发时间
      arriveDate: {},//回程时间 formatDate(new Date(),2)
      minDate: '',
      maxDate: '',
      cplx1: '10901',
      // roundtrip: 0, // 0 单程 1 往返 2需求单
      way: 1, //1 出发城市  2到达城市
      Departuredate:'',
      Departurecity:'',
      Arriveinthecity:'',
      Total:'',
      Checkindate:'',
      Checkoutdate:'',
      checked: false,
      checked1: true,
      value: '单程',
      columns: ['单程', '往返', '多程'],
      showPicker: false,
      radio:false,
      subjectCode:{
        show:false,
        must:false,
        write:false
      },
      jp:[{}],
      jd:[{}],
    }
  },
  computed: {
    ...mapGetters({
      travelerList: 'trip/travelerList',
      params: 'trip/params',
      tkSearchInfo: 'tk/tkSearchInfo',
      tkIntSearchInfo: 'tkInt/tkIntSearchInfo',
      trSearchInfo: 'tr/trSearchInfo',
      htSearchInfo: 'ht/htSearchInfo',
      tk: 'trip/tk',
      tkInt: 'trip/tkInt',
      ht: 'trip/ht',
      tr: 'trip/tr',
      tripType: 'tripType',
      userInfo:'userInfo',
      pageCtrl: 'serviceCtrl', //页面控制信息

    }),
    zys : {//总价
      get(){
        return (Number(this.params.jtys) + Number(this.params.zsys) + Number(this.params.qtys)) || 0
      },
      // set方法只写下面这一行也是可以的
      set(){}
    },
    jtys () {
      let jtys = 0
      this.params.vipRoute.forEach(item => {
        if(item.proType!=10903){
          jtys += Number(item.fyys) * (item.cxrId ? item.cxrId.split(',').length : 1)
        }
        if(this.value == '单程'){
          if(item.proType == 10901){
            this.jp = {item}
            console.log('this',this)
          }
          return false
        }else if (this.value == '往返'){
          console.log('往返')
        }


      })
      return jtys
    },
    zsys () {
      let zsys = 0
      this.params.vipRoute.forEach(item => {

        zsys += Number(item.fyys)
        if(item.proType==10903){
          if(this.value == '单程'){
            this.jd = {item}
            console.log(this.jd,'555')
          }else if (this.value == '往返'){
            console.log('往返')
          }
        }
      })
      return zsys
    },
    ccsqdId () {//申请单详情 获取申请单ID
      return this.params.ccsqdId
    },
    title () {//标题
      if (this.ccsqdId) {
        return '修改出差申请单'
      } else {
        return '新增出差申请单'
      }
    },
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    this.tkSearchInfo.flights=[]
    this.$store.commit('tk/CLEAR_ALL',{})
    this.$store.commit('tkInt/CLEAR_ALL',{})
    this.$store.commit('ht/CLEAR_ALL',{})
    // this.$store.commit('tr/CLEAR_TRSEARCHINFO',{})
    next()
  },

  activated () {
    this.params.zsys = this.zsys
    this.params.jtys = this.jtys

  },
  updated (){

  },
  created () {
    if (this.ccsqdId) {//获取草稿申请单详情
      this.getInfo()
    } else {
      this.init()
    }
    // 判断是否自动打开酒店开关
    if(this.Departuredate==''){
      this.checked = false
    }else{
      this.checked = true
    }
  },
  methods: {
    RoundTripEvents(index,item) {
      this.index= index
    },
    input(event){
      setTimeout(()=>{
        this.apply.Multireach[0].Reasons=event.target.value
      },1500)
      console.log('输入事件触发了',this.apply.Multireach[0].Reasons)
    },
    // 添加往返的行程事件
    Addatrip(){
      console.log('添加行程',this)
      if(this.apply.Multireach.length == 2
      ){
        this.$toast('暂不支持更多的行程')
      }
      let statusType = true
      this.apply.Multireach.forEach((item) => {
        console.log(item,'status')
        if (
          item.Departurecity == '' ||
          item.ProjectName == '' ||
          item.RoundTripDepartureDate == ''

        ){
          statusType = false
        }
      })
      this.khlist = true
      if (statusType) {
        this.apply.Multireach.push({
          Departurecity :'',
          ProjectName :'',
          RoundTripDepartureDate:'',
        })
      }
    },
    // 选择城市的回调
    cityChange(info, way){
      if(way =='1'){
        this.Departurecity = info.cityName
      }else if(way =='2'){
        this.Arriveinthecity = info.cityName
      }else if(way =='1.1'){
        // 多程的城市
        if(this.index == 1){
          this.apply.Multireach[0].Departurecity = info.cityName
        }else if(this.index == 2){
          this.apply.Multireach[1].Departurecity = info.cityName
        }
      }
      console.log(this)
    },
    getAirport(way){
      console.log(way)
      if(this.value == '单程'){
        if(!this.params.ccsy){
          this.$toast('请输入出差事由')
          return
        }else{
          if (!this.pageCtrl.isChangeVoyage) {
            return
          }
          if (way == 3) {
            [this.tkSearchInfo.depport, this.tkSearchInfo.arrport] = [this.tkSearchInfo.arrport, this.tkSearchInfo.depport]
            if (this.tkSearchInfo.queryStr.departAirport) { //有缓存数据获取差旅政策bug
              this.tkSearchInfo.queryStr.departAirport = this.tkSearchInfo.depport.threeCode
            }
            if (this.tkSearchInfo.queryStr.arriveAirport) { //有缓存数据获取差旅政策bug
              this.tkSearchInfo.queryStr.arriveAirport = this.tkSearchInfo.arrport.threeCode
            }
            this.getClbz()
          } else if (this.pageCtrl.isChangeVoyage) {
            this.way = way
            this.$refs.city.toggle()
          }
        }
      }else if(this.value == '往返'){
        if(!this.params.ccsy){
          this.$toast('请输入出差事由')
          return
        }else{
          if (!this.pageCtrl.isChangeVoyage) {
            return
          }
          if (way == 3) {
            [this.tkSearchInfo.depport, this.tkSearchInfo.arrport] = [this.tkSearchInfo.arrport, this.tkSearchInfo.depport]
            if (this.tkSearchInfo.queryStr.departAirport) { //有缓存数据获取差旅政策bug
              this.tkSearchInfo.queryStr.departAirport = this.tkSearchInfo.depport.threeCode
            }
            if (this.tkSearchInfo.queryStr.arriveAirport) { //有缓存数据获取差旅政策bug
              this.tkSearchInfo.queryStr.arriveAirport = this.tkSearchInfo.arrport.threeCode
            }
            this.getClbz()
          } else if (this.pageCtrl.isChangeVoyage) {
            this.way = way
            this.$refs.city.toggle()
          }
        }
      }else{
        if(!this.params.ccsy){
          this.$toast('请输入出差事由')
          return
        }else{
          if (!this.pageCtrl.isChangeVoyage) {
            return
          }
          if (way == 3) {
            [this.tkSearchInfo.depport, this.tkSearchInfo.arrport] = [this.tkSearchInfo.arrport, this.tkSearchInfo.depport]
            if (this.tkSearchInfo.queryStr.departAirport) { //有缓存数据获取差旅政策bug
              this.tkSearchInfo.queryStr.departAirport = this.tkSearchInfo.depport.threeCode
            }
            if (this.tkSearchInfo.queryStr.arriveAirport) { //有缓存数据获取差旅政策bug
              this.tkSearchInfo.queryStr.arriveAirport = this.tkSearchInfo.arrport.threeCode
            }
            this.getClbz()
          } else if (this.pageCtrl.isChangeVoyage) {
            this.way = way
            this.$refs.city.toggle()
          }
        }
      }

    },
    // 选择类型回调
    onConfirm(value) {
      this.value = value
      this.showPicker = false
      console.log(value,'000')
      if(value == '单程'){
        this.roundtrip = 0
        this.businesstrip = true
        this.roundt = false
        this.roundtrip_chengshi = true
        this.roundtrip_chufariqi = false
        this.roundtripisby = true//打开往返事由
        this.Multipletravelmodules= false//关闭多程模块替换
        this.roundtripcontrol = false
        this.button = false
      }else if(value == '往返'){
        console.log(this.params)
        this.roundtrip = 1
        this.businesstrip = false
        this.roundt = true
        this.roundtrip_chengshi = true
        this.roundtrip_chufariqi = false
        this.roundtripisby = true//打开往返事由
        this.Multipletravelmodules= false//关闭多程模块替换
        this.roundtripcontrol = false
        this.button = false
      }else if(value == '多程'){
        var chineseNum = {
          0: '零',
          1: '一',
          2: '二',
          3: '三',
          4: '四',
          5: '五',
          6: '六',
          7: '七',
          8: '八',
          9: '九'
        }
        var num = this.apply.Multireach.length
        this.appl = chineseNum[num]
        console.log(this.apply.Multireach.length)
        this.roundtrip_chengshi = false
        this.roundtrip_chufariqi = true
        this.businesstrip = false
        this.roundtripisby = false//打开往返事由
        this.Multipletravelmodules= true//打开多程模块替换
        this.roundtripcontrol = true
        this.button = true
      }
    },
    changefocus,
    init () {
      this.params.zsys = this.zsys
      this.params.jtys = this.jtys

      //默认当前人为出差人
      this.userInfo.empInfo.checked=true
      this.userInfo.empInfo.clkFlag=2
      this.params.ccrPerson=[this.userInfo.empInfo]
      this.params.ccr=getName(this.userInfo.empInfo)
      this.params.ccrId = getEmpId(this.userInfo.empInfo)
      this.$store.commit('trip/travelerList', this.params.ccrPerson)

      this.needApproval()//获取默认审批规则
      this.defaultCostCenter()//获取默认的成本中心
      this.getDefaultSpgz()

      //20012 科目码是否显示
      //20013 科目码是否必填
      //20014 科目码是否支持手输
      queryParameter('20012,20013,20014').then(arr => {
        if(arr&&arr.length){
          arr.forEach(item=>{
            if(item.paramNo==20012){
              this.subjectCode.show=(item.value1==1)
            }else if(item.paramNo==20013){
              this.subjectCode.must=(item.value1==1)
            }else if(item.paramNo==20014){
              this.subjectCode.write=(item.value1==1)
            }
          })
        }
      })
    },
    getDefaultSpgz(){
      this.$api['approval/matchGz']({
        projectId:this.params.projectId,
        empId:this.params.ccrId,
        deptId:'',
        cplx: '',
      }).then(res=>{
        var cache=res.data||{}
        if(cache.gzid){
          this.params.appId=cache.gzid
          this.params.gzmc=cache.gzmc +'('+cache.gzdm+')'
        }
      })
    },
    //获取出差申请单详情
    getInfo () {
      this.$api['common/vipCcsqdGetInfo']({ ccsqdId: this.ccsqdId }).then(res => {
        let cache = res.data || {}
        cache.vipPerson=cache.personList
        this.tk.route = []
        let self = this
        let routeArr=[]
        if (cache.allRouteList && cache.allRouteList.length > 0) {
          cache.allRouteList.forEach(item=>{
            item.forEach(el=>{
              routeArr.push(el)
              if (el.proType == 10901) {
                self.tk.route.push(el)
              } else if (el.proType == 10902) {
                self.tkInt.route.push(el)
              } else if (el.proType == 10903) {
                self.ht.route.push(el)
              } else if (el.proType == 10904) {
                self.tr.route.push(el)
              }
            })
          })
        }
        cache.vipRoute=routeArr
        cache.project=cache.project == '0' ? false : true
        cache.ccrPerson=[cache.vipPerson.find(v => v.sxr == 0) || this.userInfo.empInfo]
        this.$store.commit('trip/travelerList', cache.ccrPerson)
        delete cache.personList
        delete cache.allRouteList
        this.$store.commit('trip/params', cache)
        this.needApprovalName()
      })
    },
    //保存草稿  submit   num = 1;    //提交送审   num = 2
    submit (num) {
      if(!this.params.ccr){
        this.$toast('请选择出差人')
        return
      }

      if(!this.params.costCenterId){
        this.$toast('请选择成本中心')
        return
      }
      if(!this.params.ccsy){
        this.$toast('请输入出差事由')
        return
      }
      if (!this.Departurecity) {
        this.$toast('出发城市不能为空')
        return
      }

      if(this.value == '单程'){

        if (!this.Departuredate) {
          this.$toast('出发日期不能为空')
          return
        }
        if(this.businesstrip == false){
          if (!this.Checkindate) {
            this.$toast('入住日期不能为空')
            return
          }
        }else if(this.checked1 == true){
          if (!this.params.projectName) {
            this.$toast('请选择项目名称')
            return
          }
        }
        if (!this.Arriveinthecity) {
          this.$toast('到达城市不能为空')
          return
        }
      }
      if(this.value == '往返'){
        if (!this.Checkoutdate) {
          this.$toast('返程日期不能为空')
          return
        }
        if (!this.Arriveinthecity) {
          this.$toast('到达城市不能为空')
          return
        }
      }
      // 处理 出差人 和  随行人 ;
      let arr=[]
      this.params.vipPerson.forEach((item,index) => {
        console.log(item,index,'5555')
        item.xcxh= index
        arr.push({
          'cxrName': getName(item),
          // 'deptName': '',
          'empDeptid': item.deptId,
          'empId': item.empId,
          // 'empName': item.empName,
          // 'empNo': item.empNo,
          // 'empRank': item.empRank,
          // 'empRankName': '',
          'exPerson': item.clkFlag==2?0:1,//是否外来人员
          //'idNumber': item.idNumber,
          // 'passport': item.passport,
          // 'personId': '',
          // 'phoneNumber': item.phoneNumber,
          'sxr': item.sxr
        })
      })
      this.params.vipPerson = arr
      this.params.vipRoute.forEach((item, index)=> {
        item.xcxh = index
      })
      if(this.businesstrip == false){
        if(this.Departuredate > this.Checkindate){
          this.$toast('入住日期不能早于出发日期')
        }
      }
      if(!this.params.gzmc) {
        this.$toast('请选择审批规则!')
      } else if(num == 2 && this.params.vipRoute.length < 0) {
        this.$dialog.confirm({
          title: this.$t('C474','提示'),
          message: '您未选择行程？是否提交送审'
        }).then(() => {
          this.toApplyAjax(num)
        }).catch(() => {
        })
      } else {
        this.toApplyAjax(num)
      }
    },
    //去提交申请 和 草稿  ajax
    toApplyAjax (num) {
      console.log(num)
      this.params.zys = this.zys
      this.params.addMethod = num
      this.params.project = this.params.project ? 1 : 0
      //删除的行程id
      //删除的出行人id
      let params = this.params
      params.vipRoute.forEach(o => {
        delete o.xh
      })

      if(this.value == '单程'){
        var DanChenG = {
          Departurecity:this.Departurecity,
          Arriveinthecity:this.Arriveinthecity,
          Departuredate:this.Departuredate,
          Checkindate:this.Checkindate,
          Checkoutdate:this.Checkoutdate
        }
        this.params.remark = 1
        this.params.dateBegin = this.Departuredate
        this.params.dateEnd = this.Checkoutdate
        this.params.mdd = JSON.stringify(DanChenG)
      }else if(this.value == '往返'){
        var roundTrip = {
          Departurecity:this.Departurecity,
          Arriveinthecity:this.Arriveinthecity,
          Departuredate:this.Departuredate,
          Checkindate:this.Checkindate,
          Checkoutdate:this.Checkoutdate
        }
        this.params.remark = 2
        this.params.dateBegin = this.Checkindate
        this.params.dateEnd = this.Checkoutdate
        this.params.mdd =  JSON.stringify(roundTrip)
        this.Departuredate = ''
      }else if(this.value =='多程'){
        this.params.remark = 3
        var obj = [{
          Departurecity1:this.Departurecity,
          Departuredate1:this.Departuredate,
          destination:this.apply.Multireach[0].Departurecity,

        },{
          destination:this.apply.Multireach[1].Departurecity,
          Departuredate:this.apply.Multireach[1].RoundTripDepartureDate,
        }]
        this.params.dateBegin = this.Departuredate
        // this.params.mdd = this.Departurecity+'->'+this.apply.Multireach[0].Departurecity+'->'+this.apply.Multireach[1].Departurecity
        this.params.mdd = JSON.stringify(obj)
        console.log('多程',obj)
      }
      console.log('rhis',this)
      this.$api['common/vipCcsqdAdd'](params).then(res => {
        console.log(res,'7777')
        let cache = res.data || {}
        if (!cache.ccsqdId) {
          this.$toast('送审失败')
          return
        }
        if(num == 1&&cache.ccsqdId) { // 保存草稿
          this.$dialog.alert({
            title: this.$t('C474','提示'),
            message: '保存草稿成功！'
          }).then(() => {
            this.toList()
          })
        }
        if (num == 2&&cache.ccsqdId) { // 提交送审   送审成功时，清除缓存
          this.$dialog.alert({
            title: this.$t('C474','提示'),
            message: '已送审！'
          }).then(() => {
            this.toList()
          })
        }
      })
    },
    //添加修改型行程
    addRouters() {
      console.log(this)
      if(this.value == '单程'){
        if(this.jp.length == 2){
          this.$toast('单程模式')
        }else{
          this.addRoute(10901+'')
        }
      }
    },
    addRoute (cplx) {
      console.log(cplx)
      if(cplx == 1903){
        this.dateType = 'range'
        this.arriveDate = formatDate(this.departDate.date, 1)
        this.showDate()
      }
    },
    clear () {
      this.$store.commit('trip/CLEAR_ALL')
      this.$store.commit('trip/CLEAR_PARAMS')
    },
    //删除行程
    deletRoute (index) {
      this.$dialog.confirm({
        title: this.$t('C474','提示'),
        message: '确定删除当前行程？'
      }).then(() => {
        this.params.vipRoute.splice(index,1)
        this.params.zsys=this.zsys
        this.params.jtys=this.jtys
      })
    },
    //出差人控件
    openEmpList(type){
      if (type=='ccr') {
        this.radio=true
        this.$store.commit('trip/travelerList',this.params.ccrPerson)
        this.$refs.empList.toggle({ index: 1, showTabIndex: [1] })
      } else if (type=='sxr') {
        if(this.params.ccrPerson.length==0){
          this.$toast('请先选择出差人')
          return
        }
        this.radio=false
        this.$store.commit('trip/travelerList',this.params.vipPerson)
        this.$refs.empList.toggle({ index: 0, showTabIndex: [0, 1, 2] })
      }
    },
    //出差人 回调
    ccrCallBack (emp) {
      this.params.ccr = getName(emp)
      this.params.ccrId = getEmpId(emp)
      this.params.ccrPerson=[emp]
      this.getDefaultSpgz()
    },
    //同行人 回调
    cxrCallBack (list) {
      if (list) {
        let sxr=list.map(item=> {
          return getName(item)
        })
        let sxrId=list.map(item=> {
          return getEmpId(item)
        })
        this.params.sxr = sxr.join(',')
        this.params.sxrId = sxrId.join(',')
        this.params.vipPerson=list
      }
    },
    //项目 成本中心 科目码  审批规则 回调
    checkCallBack (info) {
      if (info.gzId) {
        info.appId=info.gzId
        info.gzmc=info.gzmc +'('+info.gzdm+')'
      }
      if (info.svalue) {
        this.params.subjectCode =info.svalue
      }
      if(info.projectName){
        this.getDefaultSpgz()
      }
      Object.assign(this.params, info)
      this.needApproval()
      this.defaultCostCenter()
    },
    showDate(val){
      if(!this.params.ccsy){
        this.$toast('请输入出差事由')
        return
      }else{
        if(val ==1){
          this.$refs.date.toggle({
            defaultDate: this.roundtrip == 0 ? this.departDate.date : [this.departDate.date, this.arriveDate.date],
            minDate: this.minDate,
            maxDate: this.maxDate
          })
        }else if(val ==2){
          console.log(val,'2')
          this.roundtrip = 1
          this.dateType = 'range'
          this.$refs.date.toggle({
            defaultDate:[this.params.dateBegin,this.params.dateEnd],
          })
        }
      }
    },
    //日期 回调
    getDate (data) {
      if (Array.isArray(data)) {
        this.Checkindate = data[0]//入住日期
        this.Checkoutdate = data[1]//离店日期
      } else {
        this.departDate = formatDate(data)
        if(this.index == 1){
          this.apply.Multireach[0].RoundTripDepartureDate = data
          this.Departuredate = data
        }else if(this.index == 2){
          console.log(this.Departuredate ,this.apply.Multireach)
          if(this.Departuredate >data){
            this.$toast('入住日期不能早于出发日期')
          }else{
            this.apply.Multireach[1].RoundTripDepartureDate = data
          }
        }else{
          this.Departuredate = data
        }
      }

    },
    toggle (name, type) {
      // this.$store.commit('trip/CLEAR_TRAVELERlIST')
      if(!this.params.ccsy){
        this.$toast('请输入出差事由')
        return
      }else{
        this.$refs[name].toggle(type) // type : {radio:true|false} || 0 1 2 3
      }

    },
    back () { //定向 返回列表
      this.$dialog.confirm({
        title:this.$t('C474','提示'),
        message: '您确认放弃本次操作'
      }).then(() => {
        this.toList()
      })
    },
    toList () {
      // this.clear()
      this.$router.push({path:'/khList'})
    },
    //获取到审批规则id (post)  获取默认的审批规则
    needApproval () {
      if (this.params.appId) return
      this.$api['approval/vipSpkzNeedApproval']({
        'bookEmpId': this.userInfo.empInfo.empId,
        'djlx': '11099',
        'ifViolate': '0',
        'projectId': this.params.projectId,
        'travelEmpIds': this.params.sxrId
      }).then((res) => {
        let cache = res.data || {}
        this.params.appId = cache.spgzId
        this.needApprovalName()
      })
    },
    //获取到审批规则名称(get)
    needApprovalName () {
      if (!this.params.appId) return false
      this.$api['approval/vipSpgzFindDetail']({
        gzid: this.params.appId
      }).then(res => {
        let cache = res.data || {}
        this.params.gzmc = cache.gzmc + '(' + cache.gzdm + ')'
      })
    },
    // 获取默认的成本中心
    defaultCostCenter () {
      if (this.params.costCenterId) return
      this.$api['common/costCenterFindList']({
        projectId: this.params.projectId,
        travelEmpd: this.params.ccrId,
        txEmpIds:this.params.sxrId
      }).then(res => {
        let cache = res.data || {}
        if (cache.defaultCostCenter) {
          Object.assign(this.params, cache.defaultCostCenter)
        } else if(cache.list){
          Object.assign(this.params, cache.list[0])
        }
      })
    }
  },

  watch: {

    'params.crr' (val) {
      console.log(val,'8888')
    },
    roundtrip (val) {
      console.log(val,'--*')
      if (this.pageCtrl.isChangeDate) {
        if (val == 0) {
          this.dateType = 'single'
          this.arriveDate = {}
        } else if (val == 1) {
          this.dateType = 'range'
          this.arriveDate = formatDate(this.departDate.date, 1)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  height: calc(100vh - 96px);
  overflow: hidden;
}
.pad-t-5{
  padding-top: 14px;
}
.pad-r-10{
  padding-right: 10px;
}
.pad-l-10{
  padding-left: 10px;
}
.pad-b-50{
  padding-bottom: 60px;

  div{
    ul{
      margin: 10px 10px 10px 10px;
      background-color: rgba(171, 171, 209, 0.2);
      border-radius: 5px;
      li{

      }
    }
    ul:nth-child(2){
      height:100%;
      background-color: rgba(171, 171, 209, 0.2);
      li:nth-child(1){
        border-bottom: 1px solid #fff;

      }
      li{
        span{
          border-bottom: 1px solid #fff;
        }
      }
    }
  }
}
/deep/ .van-icon{
  color: #000000;
}
.kh-sy{
  width: 225px;
  height: 40px;
  background: #e0e0ef;
  text-align: center;
  border-radius: 5px;
  border: none;
}

/deep/ .van-cell{
  background-color: #fff0;
}
.khto{
  background: #8282ab;
  width: 100%;
  display: flex;
  height: 46px;
  align-items: center;
  justify-content: space-between;
  padding: 0px 6px 0 23px;
}
/deep/ .van-nav-bar__title{
  color:#fff;
  font-size: 15px;
  font-weight: 400;
}
/deep/ .van-nav-bar .van-icon{
  //color: #fff;
}
.mescroll{
  background:#fff;
}
.khbutton{
  width: 66px;
  height: 30px;
  border-radius: 12px;
  border:none;
  background: linear-gradient(270deg, rgba(111, 113, 237, 1) 13%, rgba(118, 80, 228, 1) 92%, rgba(118, 78, 228, 1) 96%);
}
.khdis{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  button{
    margin:0 0 0 0
  }
}
.khbutton1{
  width: 66px;
  height: 30px;
  border-radius: 12px;
  border: 1px solid #6f70ed;
  color: #6f70ed;
}
/deep/ .van-field__control--right{
  font-size: 12px;
  color: #656464;
  font-weight: 400;
}

.roundtripbutton{
  background-color: rgba(56, 99, 208, 1);border: none;width: 394px;height: 40px;margin: 5px 0px 5px 10px;
}
</style>
